import { imageUploadSlice } from "../../store/slices/ImageUploads";
import { postImageAsync } from "../../api/apiRequests";
import axios from "axios";
import {
  PhotoUploadErrors,
  getPhotoValidationErrorFromMessage
} from "../../photoUploadErrors";
import { getOnlineStatus } from "../../hooks/useOnlineStatus";

export const handlePhotoUpload = (
  images,
  dispatch,
  currentHelper,
  cancelTokenDispatch,
  appraisalSessionId
) => {
  let retries = 0;

  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  cancelTokenDispatch({ type: "SET_CANCEL_TOKEN", payload: source });

  dispatch(imageUploadSlice.actions.clearUploadValidationError());

  images.forEach((image) => {
    const attemptRequest = async (image) => {
      try {
        await postImageAsync(appraisalSessionId, image, (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 99) / progressEvent.total
          );
          dispatch(
            imageUploadSlice.actions.setImages({
              imageSrc: image.srcUrl,
              progress: percentCompleted,
              group: currentHelper.id
            })
          );
          dispatch(imageUploadSlice.actions.setCurrentUploads(image.srcUrl));
        }).then((res) => {
          const imageIdentifier = res.result;
          if (res.error || !imageIdentifier) {
            throw new Error(
              `${res?.error?.code}: ${res?.error?.errorDetailsList[0]?.message}` ||
                "An error has occured saving image to API"
            );
          }
          dispatch(imageUploadSlice.actions.setRetryingRequest(0));
          dispatch(
            imageUploadSlice.actions.setImages({
              imageSrc: image.srcUrl,
              progress: 100,
              imageIdentifier
            })
          );
          dispatch(
            imageUploadSlice.actions.setCurrentImageIdentifiers(imageIdentifier)
          );
        });
      } catch (e) {
        if (source.token.reason) return;
        if (e?.message?.includes("ValidationFailed")) {
          const uploadError = getPhotoValidationErrorFromMessage(e.message);
          dispatch(
            imageUploadSlice.actions.setUploadValidationError(uploadError)
          );
          await dispatch(
            imageUploadSlice.actions.deleteImage({ imageSrc: image.srcUrl })
          );
          return;
        }
        dispatch(imageUploadSlice.actions.setUploadError(true));
        retries++;
        dispatch(imageUploadSlice.actions.setRetryingRequest(retries));
        setTimeout(() => {
          attemptRequest(image);
        }, 3000);

        if (retries === 6) {
          const isOnline = getOnlineStatus();
          if (!isOnline) {
            dispatch(
              imageUploadSlice.actions.setUploadValidationError(
                PhotoUploadErrors.OFFLINE
              )
            );
          }
          return;
        }
      }
    };
    attemptRequest(image);
  });
};
